<template>
    <div v-loading="isLoading || isLoadingAgreement" style="min-height: 50px">
        <div v-if="$hasPermission('affiliate_sales.show')" class="card-title ml-2">Доп продукты <button v-if="$hasPermission('affiliate_sales.create')" @click="createSaleVisible = true" class="btn btn-link text-success p-0" style="line-height: 1"><i class="fas fa-plus"></i></button></div>
        <div class="row">
            <div class="col-md-6" v-for="sale in sales"><AffiliateSaleItem @saved="fetchSales" :sale="sale" /></div>
        </div>
        <ModalCreate v-if="createSaleVisible" :visibleModal.sync="createSaleVisible" @saved="fetchSales" :deal-id="deal_id" />

        <div v-if="$hasPermission('additional_agreements.show')" class="card-title ml-2">Доп соглашение <button v-if="$hasPermission('additional_agreements.create') && !agreement" @click="createAgreementVisible = true" class="btn btn-link text-success p-0" style="line-height: 1"><i class="fas fa-plus"></i></button></div>
        <div class="row" v-if="agreement">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body p-2">
                        <el-row :gutter="12">
                            <el-col :span="12">
                                Соглашение от
                            </el-col>
                            <el-col :span="12" class="text-right">
                                {{formatDate(agreement.document_date)}}
                            </el-col>
                            <el-col :span="12">
                                <span>Сумма доп оборудования</span>
                            </el-col>
                            <el-col :span="12" class="text-right">
                                <span>{{(agreement.sale_amount / 100) | formatNumber}}</span>
                            </el-col>
                            <el-col :span="24" class="small">
                                <div class="mt-2">
                                    <div v-for="i in agreement.sale_items">{{i.name}} x {{i.quantity}} = {{i.amount | formatNumber}}</div>
                                </div>
                            </el-col>
                            <el-col v-if="$hasPermission('additional_agreements.update')" :span="24" class="text-right">
                                <button type="button" class="btn btn-sm btn-link pr-0" @click="editAgreementVisible = true">Редактировать</button>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
        </div>
        <ModalCreateAgreement v-if="createAgreementVisible" :visibleModal.sync="createAgreementVisible" @saved="fetchAgreement" :deal-id="deal_id" />
        <ModalEditAgreement v-if="agreement && editAgreementVisible" :visibleModal.sync="editAgreementVisible" @saved="fetchAgreement" :agreement-id="agreement.id" />
    </div>
</template>

<script>
import AffiliateSaleItem from "./AffiliateSaleItem";
import ModalCreate from "../affiliate_sales/ModalCreate";
import ModalCreateAgreement from "../additional_agreements/ModalCreate";
import ModalEditAgreement from "../additional_agreements/ModalEdit";
export default {
    name: "TabAffiliateSales",
    components: {ModalCreate, AffiliateSaleItem, ModalCreateAgreement, ModalEditAgreement},
    props: ['deal_id'],
    data: () => ({
        isLoading: false,
        isLoadingAgreement: false,
        createSaleVisible: false,
        createAgreementVisible: false,
        editAgreementVisible: false,
        sales: [],
        agreement: null,
    }),
    mounted() {
        this.fetchSales();
        this.fetchAgreement();
    },
    methods: {
        formatDate(d) {
            return moment(d).format('DD.MM.YYYY');
        },
        fetchSales() {
            if (!this.$hasPermission('affiliate_sales.show')) return;
            this.isLoading = true;
            axios.get('/api/affiliate_sales', {
                params: {deal_id: this.deal_id}
            })
                .then(res => {
                    this.sales = res.data.data;
                    this.isLoading = false;
                })
        },
        fetchAgreement() {
            if (!this.$hasPermission('additional_agreements.show')) return;
            this.isLoadingAgreement = true;
            axios.get('/api/additional_agreements', {
                params: {deal_id: this.deal_id}
            })
                .then(res => {
                    let items = res.data.data;
                    if (items.length) this.agreement = _.first(items);
                    this.isLoadingAgreement = false;
                })
        },
    }
}
</script>

<style scoped>

</style>
